import AwaitingEsignIcon from '@/components/icons/AwaitingEsignIcon';
import DraftIcon from '@/components/icons/DraftIcon';
import UnderReviewIcon from '@/components/icons/UnderReviewIcon';
import { BankingInfoResponse } from '@/types/bankingInfo';
import { Card, Typography, Grid, Box } from '@mui/material';

type AdvisorDashboardActiveApplicationsProps = {
  bankingInfo: BankingInfoResponse;
};

export default function AdvisorDashboardActiveApplications({
  bankingInfo,
}: AdvisorDashboardActiveApplicationsProps) {
  const { totalDraft, totalAwaitingESign, totalNeedingReview } =
    bankingInfo.bankApplicationInfo;

  const cards = [
    {
      title: 'Draft',
      count: totalDraft,
      icon: <DraftIcon />,
    },
    {
      title: 'Awaiting ESign',
      count: totalAwaitingESign,
      icon: <AwaitingEsignIcon />,
    },
    {
      title: 'Under Review',
      count: totalNeedingReview,
      icon: <UnderReviewIcon />,
    },
  ];

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Active Applications
      </Typography>
      <Grid container spacing={2}>
        {cards.map(card => {
          const { title, count, icon } = card;

          return (
            <Grid key={title} size={{ xs: 12, md: 6 }}>
              <Card elevation={0}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}>
                  <Box>
                    <Typography>Draft</Typography>
                    <Typography
                      sx={{
                        fontSize: '28px',
                        fontWeight: 'bold',
                        lineHeight: '28px',
                      }}>
                      {count}
                    </Typography>
                  </Box>
                  {icon}
                </Box>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Card>
  );
}
